export default {
  name: "dr-modal",
  props: {
    opened: {
      type: Boolean
    }
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    }
  }
};
